<template>
    <div class="container-div">
        <div>
            <img
                class="read"
                :class="{ expanded: isReadMore }"
                role="button"
                :src="require('../../images/Plus.svg')"
                alt="open-close"
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        expanded: Boolean
    },
    data() {
        return {
            isReadMore: this.expanded
        }
    },
    watch: {
        expanded(val) {
            this.isReadMore = val;
        }
    }
};
</script>

<style scoped>
.read {
    transition: transform 0.2s;
    width: 24px;
    height: 24px;
}
.read.expanded {
    transform: rotate(45deg);
}
</style>
